import script from "./ImagePreviewOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagePreviewOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./ImagePreviewOverlay.vue?vue&type=style&index=0&id=0380b27e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0380b27e"]])

export default __exports__